import { Direction } from '../../../../../lib/Map';
import { getDispatchLastStop, getDispatchWayPoints } from '../../../../mapComponents/mapHelper';
import { formatDriverLocation } from './utils';
import { observer, inject } from 'mobx-react';

const RouteDirections = ({
  selectedRoutes,
  DispatchStore,
  terminalLocation,
  disableRouteAnimation,
  routeAnimation,
  showRouteAnimation,
  stopsFieldName='stops',
  refreshOnMapStyleLoaded=undefined,
}) => {
  return selectedRoutes?.map((route) => {
    const driverLocation = formatDriverLocation(DispatchStore.driverLocations[route.driverId]);
    const truckProperties = {
      length: route.trailer.length,
      weight: route.totalWeight
    }
    return (
      <Direction
        origin={driverLocation ? null : terminalLocation}
        destination={getDispatchLastStop(route[stopsFieldName])}
        waypoints={getDispatchWayPoints(route[stopsFieldName]) ?? [{ location: terminalLocation }]} // Add terminal coordinates to waypoint list in case driver route is present but filtered stops list is empty
        strokeColor={route.color}
        data={route}
        key={route.routeId} //routeId changes for each update which will unmount this component
        zIndex={0}
        onAnimationDone={disableRouteAnimation}
        routeAnimation={Boolean(routeAnimation && showRouteAnimation)}
        enableRouteHover
        driverLocation={driverLocation}
        refreshOnMapStyleLoaded = {refreshOnMapStyleLoaded}
        truckProperties={truckProperties}
      />
    );
  });
};

export default inject('DispatchStore')(observer(RouteDirections));
